<template>
	<div style="height: 100%;">
		<div v-if="!$route.query.core" style="width: 75rem;margin: 0 auto">
			<p style="font-size: 20px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: bold;
			color: #333333;margin: 0;display: flex;justify-content: center;margin-top: 2rem;">
						{{noticeData.title}}
					</p>
		</div>
		<div v-if="!$route.query.core" style="display: flex;width: 75rem;margin: 0 auto;">
			<a-row style="width: 100%;margin-left: 200px;margin-top: 25px;">
				<a-col :span="6">
						<p style="font-weight: bold;">发布时间: {{noticeData.createTime}}</p>
				</a-col>
				<a-col  :span="6" >
						<p style="font-weight: bold;">发布平台: {{noticeData.labName}}</p>
				</a-col>
				
				<a-col :span="6" >
						<p style="font-weight: bold;">阅读量: {{noticeData.readTime}}</p>
				</a-col>
				<a-col :span="6" >
						<p style="font-weight: bold;">附件: <a target="_blank" :href="noticeData.filePath">{{noticeData.fileName}}</a></p>
				</a-col>
			</a-row>
			
		</div>
		<div v-if="!$route.query.core" v-html="noticeData.content"  style="width: 75rem;margin: 0 auto;margin-top: 2rem;min-height: 700px;">
		
		</div>
		<div v-if="$route.query.core" v-html="noticeData2"  style="width: 75rem;margin: 0 auto;margin-top: 2rem;min-height: 700px;">
		
		</div>
		
	</div>
</template>

<script>
	import { scrollAnimation } from '../../utils/js/scrollAnimation.js';
	import {DynamicId,OfflineTrainingsId,logoBanner} from '@/api/index.js'
	export default{
		name: '/noticeRichDetail',
		data(){
			return{
				noticeData:[],
				noticeData2:''
			}
		},
		created(){
			console.log(this.$route.query.Ids)
			if(this.$route.query.Ids){
				let noticeDataId  = this.$route.query.Ids
				console.log(noticeDataId)
				if(this.$route.query.state==2){
					console.log(noticeDataId)
					OfflineTrainingsId({OfflineTrainingId:Number(noticeDataId)}).then((res)=>{
						this.noticeData = res.data.data[0]
						console.log(res.data.data)
					})
				}
				else{
					DynamicId({Id:noticeDataId}).then((res)=>{
						this.noticeData = res.data.data
					})
				}
				
			}
			else if(this.$route.query.core){
				logoBanner().then((res)=>{
					this.noticeData2 = res.data.data.introduction
					
				})
				
			}
			else{
				let noticeData  = this.$route.params.data
				this.noticeData = noticeData
			}
			
			
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 0)
		}
	}
</script>

<style>
</style>
